// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".actions[data-v-590f29ec] {\n  position: relative;\n}[dir=ltr] .actions[data-v-590f29ec] {\n  float: right;\n}[dir=rtl] .actions[data-v-590f29ec] {\n  float: left;\n}\n[dir=ltr] .icon[data-v-590f29ec] {\n  margin-right: 5px;\n}\n[dir=rtl] .icon[data-v-590f29ec] {\n  margin-left: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
